// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerAccountsDetail from 'syft-acp-core/entities/EmployerDetail/EmployerAccountsDetail/'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

const EmployerAccountsView = ({ match: { params } }) => (
  <TrackingProvider
    value={{
      context: {
        employer_id: Number(params.id),
        account_id: Number(params.accountID),
      },
    }}
  >
    <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
    <EmployerAccountsDetail id={Number(params.accountID)} employerID={Number(params.id)} />
  </TrackingProvider>
)

EmployerAccountsView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
      accountID: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerAccountsView
